/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetViewingDetailedStatusInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetViewingDetailedStatusOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminPermissionForbiddenDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminPermissionUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { MasterGetDashboardStatisticsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MasterGetDashboardStatisticsOkDto } from '../../src/model';
// @ts-ignore
import type { MasterGetDashboardStatisticsUnProcessableEntityResponseDto } from '../../src/model';
// @ts-ignore
import type { MasterGetReportStatisticsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { MasterGetReportStatisticsOkDto } from '../../src/model';
/**
 * MasterStatisticsApi - axios parameter creator
 * @export
 */
export const MasterStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 관리자 뷰잉하기 상세 현황 조회
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerAdminGetViewingDetailedStatus: async (startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/master/statistics/viewing/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 마스터 관리자 대시보드 통계 조회
         * @param {string} baseDate 시작 날짜
         * @param {string | null} [startDate] 데이터 범위
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerMasterGetDashboardStatistics: async (baseDate: string, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseDate' is not null or undefined
            assertParamExists('masterStatisticsControllerMasterGetDashboardStatistics', 'baseDate', baseDate)
            const localVarPath = `/master/statistics/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (baseDate !== undefined) {
                localVarQueryParameter['baseDate'] = (baseDate as any instanceof Date) ?
                    (baseDate as any).toISOString() :
                    baseDate;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 마스터 관리자 전체 리포트 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerMasterGetReportStatistics: async (page?: number, limit?: number, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/master/statistics/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 일일 통계 업데이트 백도어
         * @param {string} todayDate 시작 날짜
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerPpapapapapap: async (todayDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todayDate' is not null or undefined
            assertParamExists('masterStatisticsControllerPpapapapapap', 'todayDate', todayDate)
            const localVarPath = `/master/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todayDate !== undefined) {
                localVarQueryParameter['todayDate'] = (todayDate as any instanceof Date) ?
                    (todayDate as any).toISOString() :
                    todayDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterStatisticsApi - functional programming interface
 * @export
 */
export const MasterStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 관리자 뷰잉하기 상세 현황 조회
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterStatisticsControllerAdminGetViewingDetailedStatus(startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetViewingDetailedStatusOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterStatisticsControllerAdminGetViewingDetailedStatus(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterStatisticsApi.masterStatisticsControllerAdminGetViewingDetailedStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 마스터 관리자 대시보드 통계 조회
         * @param {string} baseDate 시작 날짜
         * @param {string | null} [startDate] 데이터 범위
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterStatisticsControllerMasterGetDashboardStatistics(baseDate: string, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterGetDashboardStatisticsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterStatisticsControllerMasterGetDashboardStatistics(baseDate, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterStatisticsApi.masterStatisticsControllerMasterGetDashboardStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 마스터 관리자 전체 리포트 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [startDate] 시작일
         * @param {string} [endDate] 종료일
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterStatisticsControllerMasterGetReportStatistics(page?: number, limit?: number, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterGetReportStatisticsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterStatisticsControllerMasterGetReportStatistics(page, limit, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterStatisticsApi.masterStatisticsControllerMasterGetReportStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 일일 통계 업데이트 백도어
         * @param {string} todayDate 시작 날짜
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async masterStatisticsControllerPpapapapapap(todayDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.masterStatisticsControllerPpapapapapap(todayDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterStatisticsApi.masterStatisticsControllerPpapapapapap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MasterStatisticsApi - factory interface
 * @export
 */
export const MasterStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary 관리자 뷰잉하기 상세 현황 조회
         * @param {MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerAdminGetViewingDetailedStatus(requestParameters: MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetViewingDetailedStatusOkDto> {
            return localVarFp.masterStatisticsControllerAdminGetViewingDetailedStatus(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 마스터 관리자 대시보드 통계 조회
         * @param {MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerMasterGetDashboardStatistics(requestParameters: MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MasterGetDashboardStatisticsOkDto> {
            return localVarFp.masterStatisticsControllerMasterGetDashboardStatistics(requestParameters.baseDate, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 마스터 관리자 전체 리포트 조회
         * @param {MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerMasterGetReportStatistics(requestParameters: MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MasterGetReportStatisticsOkDto> {
            return localVarFp.masterStatisticsControllerMasterGetReportStatistics(requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 일일 통계 업데이트 백도어
         * @param {MasterStatisticsApiMasterStatisticsControllerPpapapapapapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        masterStatisticsControllerPpapapapapap(requestParameters: MasterStatisticsApiMasterStatisticsControllerPpapapapapapRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.masterStatisticsControllerPpapapapapap(requestParameters.todayDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for masterStatisticsControllerAdminGetViewingDetailedStatus operation in MasterStatisticsApi.
 * @export
 * @interface MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatusRequest
 */
export interface MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatusRequest {
    /**
     * 시작일
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatus
     */
    readonly startDate?: string

    /**
     * 종료일
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatus
     */
    readonly endDate?: string
}

/**
 * Request parameters for masterStatisticsControllerMasterGetDashboardStatistics operation in MasterStatisticsApi.
 * @export
 * @interface MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatisticsRequest
 */
export interface MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatisticsRequest {
    /**
     * 시작 날짜
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatistics
     */
    readonly baseDate: string

    /**
     * 데이터 범위
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatistics
     */
    readonly startDate?: string | null
}

/**
 * Request parameters for masterStatisticsControllerMasterGetReportStatistics operation in MasterStatisticsApi.
 * @export
 * @interface MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatisticsRequest
 */
export interface MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatisticsRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatistics
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatistics
     */
    readonly limit?: number

    /**
     * 시작일
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatistics
     */
    readonly startDate?: string

    /**
     * 종료일
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatistics
     */
    readonly endDate?: string
}

/**
 * Request parameters for masterStatisticsControllerPpapapapapap operation in MasterStatisticsApi.
 * @export
 * @interface MasterStatisticsApiMasterStatisticsControllerPpapapapapapRequest
 */
export interface MasterStatisticsApiMasterStatisticsControllerPpapapapapapRequest {
    /**
     * 시작 날짜
     * @type {string}
     * @memberof MasterStatisticsApiMasterStatisticsControllerPpapapapapap
     */
    readonly todayDate: string
}

/**
 * MasterStatisticsApi - object-oriented interface
 * @export
 * @class MasterStatisticsApi
 * @extends {BaseAPI}
 */
export class MasterStatisticsApi extends BaseAPI {
    /**
     * 
     * @summary 관리자 뷰잉하기 상세 현황 조회
     * @param {MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterStatisticsApi
     */
    public masterStatisticsControllerAdminGetViewingDetailedStatus(requestParameters: MasterStatisticsApiMasterStatisticsControllerAdminGetViewingDetailedStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return MasterStatisticsApiFp(this.configuration).masterStatisticsControllerAdminGetViewingDetailedStatus(requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 마스터 관리자 대시보드 통계 조회
     * @param {MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterStatisticsApi
     */
    public masterStatisticsControllerMasterGetDashboardStatistics(requestParameters: MasterStatisticsApiMasterStatisticsControllerMasterGetDashboardStatisticsRequest, options?: RawAxiosRequestConfig) {
        return MasterStatisticsApiFp(this.configuration).masterStatisticsControllerMasterGetDashboardStatistics(requestParameters.baseDate, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 마스터 관리자 전체 리포트 조회
     * @param {MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterStatisticsApi
     */
    public masterStatisticsControllerMasterGetReportStatistics(requestParameters: MasterStatisticsApiMasterStatisticsControllerMasterGetReportStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return MasterStatisticsApiFp(this.configuration).masterStatisticsControllerMasterGetReportStatistics(requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 일일 통계 업데이트 백도어
     * @param {MasterStatisticsApiMasterStatisticsControllerPpapapapapapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterStatisticsApi
     */
    public masterStatisticsControllerPpapapapapap(requestParameters: MasterStatisticsApiMasterStatisticsControllerPpapapapapapRequest, options?: RawAxiosRequestConfig) {
        return MasterStatisticsApiFp(this.configuration).masterStatisticsControllerPpapapapapap(requestParameters.todayDate, options).then((request) => request(this.axios, this.basePath));
    }
}

